import { DOMAIN } from "../../../../var_env."
import { RequestResponsePattern } from "../../../../types/Request"
import { getApi } from "../../../../utils/requestApi"
import { LinksTutoriaisConfigType } from "../types"
import { setConfig, setRequestConfigData, setRequestConfigError, setRequestConfigLoading } from "../Reducers/LinksTutoriaisReducer"

export default async function getConfig(dispatch: Function, idUsuario: number) {
    try {
        dispatch(setRequestConfigLoading())
        const response: RequestResponsePattern<LinksTutoriaisConfigType> = await getApi({
            endpoint: DOMAIN,
            params: `/LinksTutoriais/permissao/config/${idUsuario}`,
        })
        if (response && !response.flagErro) {
            dispatch(setRequestConfigData(response))
            dispatch(setConfig(response.listaResultados))
        } else throw new Error(response?.listaMensagens?.[0] ?? 'Erro na requisição')
    } catch (error: any) {
        dispatch(setRequestConfigError())
    }
}
